import axios from './axios';
import { CREATE_REQUEST_HELP } from './APILinks';

export const apiCreateRequestHelp = (message, transactionId) =>
  axios.post(CREATE_REQUEST_HELP, {
    message,
    transactionId,
  });
